import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence, useDictionaryEvidence } from '@eas/common-web';
import { ExportTags } from '../../../common/export-tags';
import { SpecificTarget } from '../../../common/models';
import { initNewDisabledItem } from '../../../utils/dictionary-item';
import { useColumns } from './specific-targets-columns';
import { SpecificTargetsFields } from './specific-targets-fields';
import { useValidationSchema } from './specific-targets-schema';

export function OperatorSpecificTargets() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();

  const evidence = useDictionaryEvidence<SpecificTarget>({
    identifier: 'SPECIFIC_TARGETS',
    version: 2,
    apiProps: {
      url: '/api/ks/specific-targets',
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'KS_O_SPECIFIC_TARGETS_TABLE_TITLE',
        defaultMessage: 'Specifické cíle',
      }),
      reportTag: ExportTags.SPECIFIC_TARGET_GRID,
    },
    detailProps: {
      FieldsComponent: SpecificTargetsFields,
      validationSchema,
      initNewItem: initNewDisabledItem,
    },
  });

  return <Evidence {...evidence} />;
}
